import React from 'react';
import icInvoice from './icons/ic-invoice.svg'
import secondaryshape from './icons/secondary-shape.svg'
import IcTriangle from './icons/ic-eva_alert-triangle.svg'


export default function ServiceNotificationCard({ service }) {
    const ServicePaymentStatus = service[0]?.service_payment_status ?? "PayAtShop";

    const rendertitle = (services = []) => {
        if (!Array.isArray(services) || services.length === 0) return null;

        // Helper: Normalize name
        const normalizeName = (name) => name?.replace(/\s+/g, ' ').trim();
        // Helper: Identify any "Paid" status (Handles your specific dataset)
        const isPaid = (status) => status === 'PaidInstall' || status === 'PaidServices';

        if (services.length === 1) {
            const service = services[0];
            const name = normalizeName(service?.display_name);
            const status = service?.service_payment_status;

            if (name === "New Tire Installation") {
                // Use Case 1: Paid online
                if (isPaid(status)) {
                    return "Paid Online";
                }
                // Use Case 2: Pay at shop
                if (status === 'PayAtShop') {
                    return "Services have not been pre-paid";
                }
            }

            // Use Case 3: Tire Pick Up (pseudo-service)
            if (name === "Tire Pick Up") {
                return "Customer has declined to pay online for services.";
            }

            // Default for any other single service paying at shop
            if (status === 'PayAtShop') {
                return "Services have not been pre-paid";
            }

            // Default for any other single service paid online
            if (isPaid(status)) {
                return "Paid Online";
            }
        }
        else {
            const statuses = services.map(s => s?.service_payment_status);

            // Use Case 5, 6, 7: Everything is Pay at Shop
            const allArePayAtShop = statuses.every(s => s === 'PayAtShop');
            if (allArePayAtShop) {
                return "Customer has declined to pay online for services.";
            }

            // Check if everything is Paid (This catches your 5-item dataset)
            const allArePaid = statuses.every(s => isPaid(s));
            if (allArePaid) {
                return "Paid Online";
            }

            // Use Case 4: Mixed (Prepaid Tire + Shop Items)
            const hasPaidTire = services.some(s =>
                normalizeName(s.display_name) === "New Tire Installation" &&
                s.service_payment_status === "PaidInstall"
            );
            const hasPayAtShop = statuses.includes("PayAtShop");

            if (hasPaidTire && hasPayAtShop) {
                return "Some services have not been paid";
            }
        }

        // Default Fallback
        return "Services have not been pre-paid";
    };

    const renderSubTitle = (services = []) => {
        if (!Array.isArray(services) || services.length === 0) return null;

        // Helpers to handle data normalization and status grouping
        const normalize = (name) => name?.replace(/\s+/g, ' ').trim();
        const isPaid = (status) => status === 'PaidInstall' || status === 'PaidServices';

        if (services.length === 1) {
            const service = services[0];
            const name = normalize(service?.display_name);
            const status = service?.service_payment_status;

            // Requirement 1 & 2 (UC 1 & 2)
            if (name === "New Tire Installation") {
                if (isPaid(status)) {
                    return "Customer has pre-paid for installation";
                }
                if (status === 'PayAtShop') {
                    return "customer will pay at the Shop";
                }
            }

            // Requirement 3 (UC 3): Tire Pick up only
            if (name === "Tire Pick Up") {
                return "Consult with the customer in the store";
            }

            // Default fallback for single service
            return "Consult with the customer in the store";
        }
        else {
            const statuses = services.map(s => s?.service_payment_status);

            // Requirement 5, 6, 7 (UC 5, 6, 7): All items are Pay at Shop
            const allArePayAtShop = statuses.every(s => s === 'PayAtShop');
            if (allArePayAtShop) {
                return "Please consult with the customer about installation and other services";
            }

            // Your specific Data Set: Everything is Paid (1 PaidInstall + 4 PaidServices)
            // This acts as a multi-service version of Requirement 1
            const allArePaid = statuses.every(s => isPaid(s));
            if (allArePaid) {
                return "Customer has pre-paid for Services";
            }

            // Requirement 4 (UC 4): Mixed (Prepaid Tire + some Pay at Shop items)
            const hasPaidTire = services.some(s =>
                normalize(s.display_name) === "New Tire Installation" &&
                s.service_payment_status === "PaidInstall"
            );
            const hasPayAtShop = statuses.includes("PayAtShop");

            if (hasPaidTire && hasPayAtShop) {
                // Note: Returning the exact string from your AC Requirement 4
                return "The customer has opted to 'Pay at shop 'for some services";
            }
        }

        // Final safety fallback
        return "Consult with the customer in the store";
    };
    return (
        <div style={{
            display: 'flex',
            gap: '12px',
            backgroundColor: '#FFF8E1',         // very light yellow
            border: '1px solid #FFE0A3',        // light yellow border
            padding: '12px 16px',
            borderRadius: '8px',
            color: '#B26A00',                   // warning color
            fontFamily: 'Arial, sans-serif',
            alignItems: 'flex-start',
            marginBottom: '20px'
        }}>
            <div style={{
                fontSize: '24px',
                marginTop: '3px',
            }}>
                <img
                    src={IcTriangle}
                    style={{ height: 24, width: 24 }}
                />
            </div>
            <div>
                <div style={{
                    fontWeight: 600,
                    fontSize: '14px',
                    marginBottom: '4px',
                }}>{rendertitle(service)}</div>
                <div style={{ fontSize: '14px', }}>
                    {renderSubTitle(service)}
                </div>
            </div>
        </div>
    );


}

